import { render, staticRenderFns } from "./info.vue?vue&type=template&id=0bc650e8"
import script from "./info.vue?vue&type=script&lang=js"
export * from "./info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bc650e8')) {
      api.createRecord('0bc650e8', component.options)
    } else {
      api.reload('0bc650e8', component.options)
    }
    module.hot.accept("./info.vue?vue&type=template&id=0bc650e8", function () {
      api.rerender('0bc650e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claim/customerRecordManage/info.vue"
export default component.exports